import React from 'react';

export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: "h-8",
    default: "h-10",
    large: "h-14"
  };

  return (
    <div className={`flex items-center gap-2 logo-hover ${className}`} data-testid="logo">
      {/* ACH Logo Mark */}
      <svg 
        viewBox="0 0 56 48" 
        className={`${sizes[size]} w-auto`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background shape */}
        <rect width="56" height="48" rx="8" fill="#0F172A"/>
        
        {/* A */}
        <path 
          d="M6 38L12 14H16L22 38H18.5L17 33H11L9.5 38H6ZM12 29.5H16L14 19L12 29.5Z" 
          fill="white"
        />
        
        {/* C */}
        <path 
          d="M24 26C24 19.5 27.5 14 33 14C35.5 14 37.5 15 39 16.5L36.5 20C35.5 19 34.5 18.5 33.2 18.5C30 18.5 28 21.5 28 26C28 30.5 30 33.5 33.2 33.5C34.5 33.5 35.5 33 36.5 32L39 35.5C37.5 37 35.5 38 33 38C27.5 38 24 32.5 24 26Z" 
          fill="white"
        />
        
        {/* H */}
        <path 
          d="M42 14H46V24H50V14H54V38H50V28H46V38H42V14Z" 
          fill="white"
        />
      </svg>
      
      {/* Company Name */}
      <div className="flex flex-col">
        <span className="font-heading font-bold text-brand-navy tracking-tight text-lg leading-none">
          ACH
        </span>
        <span className="font-body text-brand-slate text-xs tracking-wider uppercase">
          Cleaning Co.
        </span>
      </div>
    </div>
  );
};

export default Logo;
